module.exports = __webpack_public_path__ + "static/img/jt_logo.2f93edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt_logo.png
// module id = Lkhk
// module chunks = 48